'use strict';

var timeline = document.querySelector('.timeline_cardHolder');
var timelineHolder = document.querySelector('.timeline_cardHolder ul');
var timelineYears = document.querySelector('.timeline_years');
var numberOfCards;
var cardWidth = document.querySelector('.timeline_card').offsetWidth;

var cards,
    cardOffsets,
    currentCard = 1,
    years = [];

// ForEach polyfill for IE
(function () {
	if (typeof NodeList.prototype.forEach === 'function') return false;
	NodeList.prototype.forEach = Array.prototype.forEach;
})();

// Debounce
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// Ease out cubic
function easeOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
	return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
}

function setOffsets() {
	cards = [];
	cardOffsets = [];
	timeline.querySelectorAll('.timeline_card').forEach(function (ele) {
		cards.push(ele);
		cardOffsets.push(ele.offsetLeft - window.innerWidth / 2 + cardWidth);
	});
}

function setActive(scrollEvent) {
	var activeCard = document.querySelector('.timeline_card-active');

	if (typeof scrollEvent == 'undefined' && activeCard == null) {
		scrollEvent = 0;
	} else if (typeof scrollEvent == 'undefined' && activeCard != null) {
		scrollEvent = document.querySelector('.timeline_card-active').offsetLeft;
	}

	var scrollLeft = scrollEvent + cardWidth / 2;

	// Gets what card is closest in position to the center!
	var cardNumber = cardOffsets.reduce(function (prev, curr) {
		return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
	});

	if (cardOffsets.indexOf(cardNumber) !== currentCard) {
		cards.forEach(function (card) {
			card.classList.remove('timeline_card-active');
			card.blur();
		});
		years.forEach(function (year) {
			year.classList.remove('timeline_years_decade_year-active');
			year.blur();
		});

		document.querySelectorAll('.timeline_years_decade').forEach(function (decade) {
			decade.classList.remove('timeline_years_decade-active');decade.blur();
		});

		currentCard = cardOffsets.indexOf(cardNumber);

		cards[currentCard].classList.add('timeline_card-active');

		// Add to parent node.
		years[currentCard].parentNode.parentNode.classList.add('timeline_years_decade-active');
		years[currentCard].classList.add('timeline_years_decade_year-active');

		if (window.innerWidth < 1025) {
			document.querySelector('.timeline_years_wrapper').scrollLeft = document.querySelector('.timeline_years_decade_year-active').offsetLeft - (window.innerWidth - 70) / 2;
		}
	}
}

function setUpTimeline() {
	var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	var isSafari = navigator.userAgent.indexOf('Safari') > -1;

	if (!(isChrome && isSafari)) {
		document.body.classList.add('safari');
	}

	cardWidth = document.querySelector('.timeline_card').offsetWidth;

	numberOfCards = 0;
	document.querySelectorAll('.timeline_cardHolder li').forEach(function (e) {
		if (!e.style.display) {
			numberOfCards++;
		}
	});

	timelineHolder.style.width = cardWidth * numberOfCards + 'px';

	if (window.innerWidth < 1025) {
		timelineYears.style.width = 70 * numberOfCards + 'px';
	} else {
		timelineYears.style.width = 'auto';
	}

	setOffsets();
	setActive();

	cards[cards.length - 1].click();
}

document.querySelectorAll('.timeline_years_decade_year').forEach(function (year) {
	years.push(year);
});

timeline.addEventListener('scroll', function (event) {
	setActive(event.target.scrollLeft);
});

var newScrollPosition;
var start, momentum;

var currentIteration = 1;

function animate() {
	// Animate timeline.
	if (currentIteration < 100) {
		timeline.scrollLeft = easeOutCubic(currentIteration, start, newScrollPosition - start + momentum, 100);
		currentIteration++;
	}
	window.requestAnimationFrame(animate);
}

window.requestAnimationFrame(animate);

document.querySelectorAll('.timeline_years_decade').forEach(function (decade) {
	decade.addEventListener('click', function (e) {
		if (this.classList.contains('timeline_years_decade') && !this.classList.contains('timeline_years_decade-active') && window.innerWidth > 1024) {
			document.querySelectorAll('.timeline_years_decade').forEach(function (decade) {
				decade.classList.remove('timeline_years_decade-active');
			});
			[].slice.call(this.querySelectorAll('.timeline_years_decade_year')).every(function (el) {
				if (!el.style.display) {
					el.click();
				}
				return el.style.display;
			});
		}
		this.classList.add('timeline_years_decade-active');
	});
});

document.querySelectorAll('.timeline_years_decade_year').forEach(function (year) {
	year.addEventListener('click', function () {
		momentum = 0;
		start = timeline.scrollLeft;
		newScrollPosition = document.querySelectorAll('.timeline_card')[years.indexOf(this)].offsetLeft - window.innerWidth / 2 + cardWidth - cardWidth / 2;
		currentIteration = 0;
	});
	year.addEventListener('keypress', function (event) {
		var code = event.charCode || event.keyCode;
		if (code === 32 || code === 13) {
			momentum = 0;
			start = timeline.scrollLeft;
			newScrollPosition = document.querySelectorAll('.timeline_card')[years.indexOf(this)].offsetLeft - window.innerWidth / 2 + cardWidth - cardWidth / 2;
			currentIteration = 0;
		}
	});
});

document.querySelectorAll('.timeline_card').forEach(function (card) {
	card.addEventListener('click', function (e) {
		momentum = 0;
		start = timeline.scrollLeft;
		newScrollPosition = e.currentTarget.offsetLeft - window.innerWidth / 2 + cardWidth - cardWidth / 2;
		currentIteration = 0;
	});
	card.addEventListener('focus', function (e) {
		momentum = 0;
		start = timeline.scrollLeft;
		newScrollPosition = e.currentTarget.offsetLeft - window.innerWidth / 2 + cardWidth - cardWidth / 2;
		currentIteration = 0;
	});
});

document.querySelectorAll('.timeline_checkBoxes input').forEach(function (ele) {
	ele.addEventListener('change', function (e) {
		var checkboxes = document.querySelectorAll('input[type="checkbox"]');
		var checkedOne = Array.prototype.slice.call(checkboxes).some(function (x) {
			return x.checked;
		});
		if (!checkedOne) {
			this.checked = true;
			e.preventDefault();
			return false;
		}
		var checkboxValue = this.value;
		if (!this.checked) {
			document.querySelectorAll('[data-type=\'' + checkboxValue + '\']').forEach(function (e) {
				e.style.display = 'none';
			});
		} else {
			document.querySelectorAll('[data-type=\'' + checkboxValue + '\']').forEach(function (e) {
				e.style.display = '';
			});
		}

		setUpTimeline();

		start = timeline.scrollLeft;
		newScrollPosition = cardOffsets[currentCard] - (window.innerWidth / 2 - cardWidth / 2);
	});
});

setUpTimeline();

var debounced = debounce(function () {
	setUpTimeline();
}, 250);

window.addEventListener('resize', debounced);